// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_sh-0";
export var checkoutRateBadgeLink = "_sh-1";